import { render, staticRenderFns } from "./supply-chain-apply.vue?vue&type=template&id=44debba2&scoped=true"
import script from "./supply-chain-apply.vue?vue&type=script&lang=ts"
export * from "./supply-chain-apply.vue?vue&type=script&lang=ts"
import style0 from "./supply-chain-apply.vue?vue&type=style&index=0&id=44debba2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44debba2",
  null
  
)

export default component.exports